module.exports = __webpack_public_path__ + "img/fblc-BFA赛区.5d8ea74a.jpg";